module.exports = __webpack_public_path__ + "img/release-primary.08fdeaf8.svg";